var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.75C8.95431 0.75 0 9.70431 0 20.75C0 31.7957 8.95431 40.75 20 40.75C31.0457 40.75 40 31.7957 40 20.75C40 9.70431 31.0457 0.75 20 0.75Z",
    fill: "#FFC043"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_99_5684)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11.4165,
    width: 16,
    height: 2.66667,
    rx: 1.33333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27.4165,
    width: 16,
    height: 2.66667,
    rx: 1.33333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 12.75H25.3334V16.75C25.3334 18.9591 23.5425 20.75 21.3334 20.75H18.6667C16.4576 20.75 14.6667 18.9591 14.6667 16.75V12.75Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 24.75C14.6667 22.5409 16.4575 20.75 18.6667 20.75H21.3334C23.5425 20.75 25.3334 22.5409 25.3334 24.75V28.75H14.6667V24.75Z",
    fill: "white",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.75C31.0457 0.75 40 9.70431 40 20.75C40 31.7957 31.0457 40.75 20 40.75V0.75Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_99_5684",
    x: 12,
    y: 11.4165,
    width: 18,
    height: 19.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_5684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_5684",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalWait);
export default __webpack_public_path__ + "static/media/approval_wait.d0a3d132c059e9b48e69cb82d1d1cbc9.svg";
export { ForwardRef as ReactComponent };